"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoCleanup = autoCleanup;

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var observer;
var map = new Map();

function autoCleanup(node, Type, props) {
  if (!observer) {
    setup();
  }

  map.set(node, {
    Type: Type,
    props: props
  });

  _reactDom.default.render(React.createElement(Type, props), node);
}

function setup() {
  observer = new MutationObserver(function (objects) {
    var toRemove = [];
    map.forEach(function (props, node) {
      if (!document.documentElement.contains(node)) {
        _reactDom.default.unmountComponentAtNode(node);

        toRemove.push(node);
      }
    });
    toRemove.forEach(function (node) {
      return map.delete(node);
    });

    if (map.size == 0) {
      observer.disconnect();
      observer = null;
    }
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}